<template>
  <div>
    <div class="flex justify-between items-center">
      <PageHeader title="Grille de primes" />
      <SecondaryButton @click="() => downloadRetributionConfigurationsPdf(selectedStoreId)">Exporter</SecondaryButton>
    </div>

    <Loading v-if="loadingRetributionConfigurations" />
    <RetributionCards
      v-else
      :retributionConfigurations="retributionConfigurations"
      :showManagerRetributionConfiguration="!isSeller"
    />
  </div>
</template>

<script>
import { PageHeader, Loading, SecondaryButton } from "@estaly/ui";
import RetributionCards from "@/components/retribution/RetributionCards.vue";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    PageHeader,
    SecondaryButton,
    RetributionCards,
    Loading,
  },

  mounted() {
    this.setSelectedStoreId(this.selectedStoreId);
    this.fetchRetributionConfigurations({ perPage: 1000 });
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    ...mapState("retributionConfigurations", ["retributionConfigurations", "loadingRetributionConfigurations"]),
    ...mapGetters("auth", ["isSeller"]),
  },

  methods: {
    ...mapActions("retributionConfigurations", [
      "fetchRetributionConfigurations",
      "downloadRetributionConfigurationsPdf",
    ]),
    ...mapMutations("retributionConfigurations", ["setSelectedStoreId"]),
  },
};
</script>
